import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetQueueAttachment } from 'domain/usecases';
import { RemoteGetQueueAttachment } from 'data/usecases/queue/remote-get-queue-attachment';

export const makeRemoteGetQueueAttachment = (attachmentId: string): GetQueueAttachment => {
  return new RemoteGetQueueAttachment(
    makeApiUrl(`/queue/requests/attachments/${attachmentId}`),
    makeAuthorizeHttpClientDecorator()
  );
};
